<template>
    <div id="listado-minutas-acuerdos-vencidos">
    <v-card>
        <v-card-title class="secondary--text mb-4">
        Acuerdos Vencidos ({{getContratoMinutasAcuerdosVencidos.length}})
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
        </v-btn>
        </v-card-title>
        <v-card-text>
         <v-row>
          <v-col cols="12">
          <v-data-table
          :headers="headers"
          :items="getContratoMinutasAcuerdosVencidos"
          :items-per-page="20"
          >
            <template v-slot:[`item.descripcion`]="{ item }"
            >
            <span
            class="text-caption font-weight-ligth">
            <cortar-texto
            :texto="item.descripcion!='' && item.descripcion!=null
            ? item.descripcion : ''"
            >
            </cortar-texto>
            </span>
            </template>

            <template v-slot:[`item.numero`]="{ item }"
            >
            <span
            class="text-h6 font-weight-medium">
            {{ item.numero }}
            </span>
            </template>
            <template v-slot:[`item.fechaHoraCumplimiento`]="{ item }"
            >
            <span
            v-show="item.fechaHoraCumplimiento !== null">
            <v-chip class="mx-2" small color="success">
            {{ new Date(item.fechaHoraCumplimiento).toISOString().split('T')[0]}}
            </v-chip>
            </span>
            </template>
            <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs}">
              <div v-bind="attrs" v-on="on">
                  <CheckVencidos
                  :acuerdo="item"  />
              </div>
              </template>
              <span>
                <div v-if="item.fechaHoraCumplimiento">
                  Desmarcar acuerdo como cumplido</div>
                <div v-if="!item.fechaHoraCumplimiento">
                  Marcar acuerdo como cumplido
                </div>
              </span>
            </v-tooltip>
            </template>
          </v-data-table>
          </v-col>
         </v-row>
    </v-card-text>
    </v-card>
    </div>
</template>
<script>
import CONTRATOS_MINUTAS_ACUERDOS_VENCIDOS from '@/graphql/querys/administracion/minutas/contratoMinutasAcuerdosVencidos.gql';
import CheckVencidos from '@/components/administracion/minutas/acuerdos/checkVencidos.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ListadoMinutasAcuerdosVencidos',
  props: {},
  data() {
    return {
      headers: [
        { text: 'Número', value: 'numero', sortable: true },
        { text: 'FLimite', value: 'fechaLimite', sortable: true },
        { text: 'FCumplimiento', value: 'fechaHoraCumplimiento', sortable: true },
        { text: 'Descripción', value: 'descripcion', sortable: true },
        { text: 'Reponsable', value: 'nombreReponsable', sortable: true },
        { text: 'Puesto', value: 'puestoResponsable', sortable: true },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
  components: {
    CheckVencidos,
    CortarTexto,
  },
  apollo: {
    contratoMinutasAcuerdosVencidos: {
      query: CONTRATOS_MINUTAS_ACUERDOS_VENCIDOS,
      variables() {
        return {
          numeroRegistros: null,
          pagina: null,
        };
      },
    },
  },

  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
  computed: {
    getContratoMinutasAcuerdosVencidos() {
      if (!this.contratoMinutasAcuerdosVencidos) return [];
      return this.contratoMinutasAcuerdosVencidos
        .map((acuerdo) => ({
          id: acuerdo.id,
          nombre: acuerdo.descripcion,
          fecha: acuerdo.fechaLimite,
          fechaHoraCumplimiento: acuerdo.fechaHoraCumplimiento,
          fechaLimite: acuerdo.fechaLimite,
          numero: acuerdo.numero,
          descripcion: acuerdo.descripcion,
          nombreReponsable: acuerdo.nombreReponsable,
          puestoResponsable: acuerdo.puestoResponsable,
        }));
    },
  },
};
</script>
